import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonActionSheet,
  IonButtons,
} from "@ionic/react";
import { useIonRouter } from "@ionic/react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Feed from "../components/Feed/Feed";
import Header from "../components/layout/Header";
import {
  getHashtagPosts,
  deleteTrend as deleteTrendAction,
  joinHashtag,
  leaveHashtag,
} from "../redux/actions/postActions";
import { getHashtag } from "../api/requests/hashtag";
import { Helmet } from "react-helmet-async";
import {
  addCircle,
  lockClosedOutline,
  settingsOutline,
  trashOutline,
  closeOutline,
  ellipsisHorizontal,
  chevronDownOutline,
} from "ionicons/icons";
import axios from "axios";
import { SERVER_URL } from "../api/client";
import { getHashtagMetadata } from "../utils/hashtagMetadata";
import CommunityStats from "../components/card/TrendsCard/CommunityStats";
import CommunityMembers from "../components/community/CommunityMembers";
import { useDispatch, useSelector } from "react-redux";
import EditCommunityModal from "../components/modal/EditCommunityModal";
import "./Hashtag.css";
function Hashtag() {
  const { t } = useTranslation();
  const { tag } = useParams();
  const router = useIonRouter();
  const location = useLocation();
  const dispatch = useDispatch();
  const [hashtagData, setHashtagData] = useState(null);
  const [isLocked, setIsLocked] = useState(false); // Track privacy state
  const [loading, setLoading] = useState(true);

  const currentProfile = useSelector((state) => state.currentProfile?.data);

  const [showActionSheet, setShowActionSheet] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  // 1. Wrap fetching logic in useCallback
  const fetchHashtagData = useCallback(async () => {
    // setLoading(true);
    try {
      const response = await getHashtag(tag);
      if (response?.status === 403) {
        setIsLocked(true);
      } else if (response?.status === 404) {
        setHashtagData(null);
      } else if (response?.status === 200) {
        setHashtagData(response.data);
        setIsLocked(false);
      }
    } catch (error) {
      console.error("Error fetching hashtag data:", error);
    } finally {
      setLoading(false);
    }
  }, [tag]);
  // 2. Trigger on mount/tag change
  useEffect(() => {
    fetchHashtagData();
  }, [fetchHashtagData]);
  // useEffect(() => {
  //   const fetchHashtagData = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await getHashtag(tag);

  //       // Handle the 403 Forbidden case
  //       if (response?.status === 403) {
  //         setIsLocked(true);
  //       } else if (response?.status === 200) {
  //         setHashtagData(response.data);

  //         setIsLocked(false);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching hashtag data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchHashtagData();
  // }, [tag]);

  const {
    title: hashtagTitle,
    desc,
    banner,
  } = getHashtagMetadata(tag, hashtagData);

  // Inside Hashtag.jsx
  const handleJoin = () => {
    dispatch(joinHashtag(tag)).then(() => {
      fetchHashtagData(); // Refresh data to update member list/status
    });
  };

  const handleLeave = () => {
    dispatch(leaveHashtag(tag)).then(() => {
      fetchHashtagData();
    });
  };

  const isMember =
    hashtagData?.members?.some(
      (member) =>
        member.toString() === currentProfile?._id?.toString() ||
        (member._id &&
          member._id.toString() === currentProfile?._id?.toString()),
    ) || false;

  const isOwner =
    currentProfile?._id &&
    hashtagData?.owner &&
    currentProfile._id.toString() === hashtagData.owner._id.toString();
  const isAdmin = !!currentProfile?.isAdmin;
  const canAction = isAdmin || isOwner;

  // UI for when the community is private
  const renderPrivateMessage = () => (
    <div style={{ textAlign: "center", marginTop: "50px", padding: "20px" }}>
      <IonIcon
        icon={lockClosedOutline}
        style={{ fontSize: "64px", color: "#666" }}
      />
      <h2>This Community is Private</h2>
      <p>You can request to join this community to view the posts in #{tag}.</p>
      <IonButton
        onClick={handleJoin}
        expand="block"
        mode="ios"
        color="primary"
        style={{ maxWidth: "300px", margin: "10px auto" }}
      >
        Request to Join
      </IonButton>
    </div>
  );

  const content = (
    <>
      {banner && (
        <div style={{ width: "100%", height: "auto", overflow: "hidden" }}>
          <img
            src={banner}
            alt={hashtagTitle}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>
      )}

      {desc && (
        <div style={{ padding: "16px 16px 0 16px", color: "#333" }}>
          <p
            style={{
              margin: 0,
              fontSize: "18px",
              lineHeight: "1.5",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {desc}
          </p>
        </div>
      )}

      <div style={{ padding: "4px 16px" }}>
        <IonButton
          onClick={() => {
            router.push(
              `/new-post${
                location.pathname.startsWith("/hashtag/")
                  ? `?post=${encodeURIComponent(
                      `#${location.pathname.split("/hashtag/")[1]}`,
                    )}`
                  : ""
              }`,
            );
          }}
          expand="block"
          mode="ios"
          color="primary"
        >
          <IonIcon
            icon={addCircle}
            slot="start"
            style={{
              marginRight: "8px",
            }}
          />
          Post to Community
        </IonButton>
        {hashtagData?.name && !isOwner ? (
          <IonButton
            onClick={isMember ? handleLeave : handleJoin}
            expand="block"
            mode="ios"
            fill="outline"
            color={isMember ? "medium" : "primary"}
            style={{ marginTop: "8px" }}
          >
            {isMember ? "Leave Community" : "Join Community"}
          </IonButton>
        ) : null}
      </div>
      <CommunityMembers tag={tag} />
      {hashtagData && (
        <CommunityStats
          postCount={hashtagData.count}
          memberCount={hashtagData.userCount}
        />
      )}
    </>
  );

  const openActionSheet = () => {
    setShowActionSheet(true);
  };

  const handleEdit = () => {
    setShowActionSheet(false);
    setShowEditModal(true);
  };

  const handleDelete = () => {
    if (!hashtagData) return;
    const tagToDelete = hashtagData.name?.replace(/^#/, "");
    if (tagToDelete) {
      dispatch(deleteTrendAction(tagToDelete));
      router.push("/trending");
    }
    setShowActionSheet(false);
  };
  // const Rules = () => {
  //   if (!hashtagData?.rules || hashtagData.rules.length === 0) return null;

  //   return (
  //     <div className="rules-preview-card">
  //       <div className="rules-header">
  //         <span className="rules-icon">📜</span>
  //         <span className="rules-title">Community Rules</span>
  //       </div>

  //       <div className="rules-horizontal-list">
  //         {hashtagData.rules.map((rule, index) => (
  //           <span key={index} className="rule-pill">
  //             {<span className="rule-bullet">•</span>}
  //             {rule}
  //           </span>
  //         ))}
  //       </div>
  //     </div>
  //   );
  // };
  const Rules = () => {
    const [isExpanded, setIsExpanded] = useState(false); // State to track toggle

    if (!hashtagData?.rules || hashtagData.rules.length === 0) return null;

    return (
      <div className="rules-preview-card">
        <div
          className="rules-header"
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span className="rules-icon" style={{ marginRight: "8px" }}>
              📜
            </span>
            <span className="rules-title">Community Rules</span>
          </div>
          {/* Chevron icon that rotates based on state */}
          <IonIcon
            icon={chevronDownOutline}
            style={{
              transition: "transform 0.3s ease",
              transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </div>

        {/* Conditional rendering based on state */}
        {isExpanded && (
          <div className="rules-horizontal-list" style={{ marginTop: "12px" }}>
            {hashtagData.rules.map((rule, index) => (
              <span key={index} className="rule-pill">
                <span className="rule-bullet">•</span>
                {rule}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  };
  // if (loading) {
  //   return (
  //     <IonPage>
  //       <IonHeader mode="ios">
  //         <Header hashtagTitle={t("Loading...")} />
  //       </IonHeader>
  //       <IonContent>
  //         <div style={{ textAlign: "center", marginTop: "50px" }}>
  //           <p>{t("Loading community data...")}</p>
  //         </div>
  //       </IonContent>
  //     </IonPage>
  //   );
  // }
  // if (!hashtagData) {
  //   return (
  //     <IonPage>
  //       <IonHeader mode="ios">
  //         <Header hashtagTitle={t("Community Not Found")} />
  //       </IonHeader>
  //       <IonContent>
  //         <div style={{ textAlign: "center", margin: "50px" }}>
  //           <p>{t("The community you are looking for does not exist.")}</p>
  //           <Link to="/trending">{t("Explore Trending Communities")}</Link>
  //         </div>
  //       </IonContent>
  //     </IonPage>
  //   );
  // }
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">
          <Header
            hashtagTitle={hashtagTitle}
            endSlot={
              canAction && (
                <IonButtons slot="end">
                  <IonButton onClick={openActionSheet}>
                    <IonIcon
                      icon={ellipsisHorizontal}
                      style={{ color: "black" }}
                    />
                  </IonButton>
                </IonButtons>
              )
            }
          />
        </IonHeader>
        <IonContent>
          {isLocked ? (
            renderPrivateMessage() // Show this if access is denied
          ) : (
            <>
              <Feed
                postsSelector={(state) => state.post.hashtagPosts[tag]}
                fetchAction={getHashtagPosts}
                fetchActionProps={{ tag }}
              >
                {content}
                <Rules />
              </Feed>
            </>
          )}
        </IonContent>
      </IonPage>

      {/* Options ActionSheet */}
      <IonActionSheet
        isOpen={showActionSheet}
        onDidDismiss={() => setShowActionSheet(false)}
        header="Community Options"
        buttons={[
          {
            text: "Edit",
            handler: handleEdit,
            icon: settingsOutline,
          },
          {
            text: "Delete",
            role: "destructive",
            handler: handleDelete,
            icon: trashOutline,
          },
          {
            text: "Cancel",
            role: "cancel",
            handler: () => setShowActionSheet(false),
            icon: closeOutline,
          },
        ]}
      />

      {/* Edit Modal */}
      <EditCommunityModal
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        communityData={hashtagData}
        onSuccess={fetchHashtagData} // 3. Pass the refresh function here
      />
    </>
  );
}

export default Hashtag;
